var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVPad = function SvgIconVPad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M40 11a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V15a4 4 0 0 1 4-4zm-26.5 6a2 2 0 0 0-2 2v2.5H9a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2.5V30a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2.5H20a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2.5V19a2 2 0 0 0-2-2zm17 8a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m7-9a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
  })));
};
export default SvgIconVPad;